import { render, staticRenderFns } from "./GridCompNew.vue?vue&type=template&id=da479e88&scoped=true"
import script from "./GridCompNew.vue?vue&type=script&lang=js"
export * from "./GridCompNew.vue?vue&type=script&lang=js"
import style0 from "./GridCompNew.vue?vue&type=style&index=0&id=da479e88&prod&lang=stylus&scoped=true"
import style1 from "./GridCompNew.vue?vue&type=style&index=1&id=da479e88&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da479e88",
  null
  
)

export default component.exports